import Back from "./Back";
import Border from "./Border";
import Color from "./Color";
import ColorBorder from "./ColorBorder";
import Default from "./Default";
import DefaultImage from "./DefaultImage";
import Facebook from "./Facebook";
import Google from "./Google";
import Instagram from "./Instagram";

const pack = {
  Default,
  DefaultImage,
  Color,
  Facebook,
  Google,
  Back,
  Instagram,
  Border,
  ColorBorder,
};
export default pack;
